import { useMutation } from "react-query";
import { useHistory } from "react-router";
import { deleteUnit } from "Requests/Units";
import { createToast } from "Utils/toastFunc";
import { CapitalizeFirstLetter, TextEllipsis } from "Utils/Uploads";

interface Tableitem {
  item: {
    id: number;
    name: string;
    regions?: {
      region: string;
    };
    addresses: {
      cities: {
        city: string;
      };
    };
    deleted_at: string | null;
    type: string;
  };
}

const formatAddressToString = (address: any) => {
  const { street, neighborhood, cities, cep, number } = address;
  return `${street}, ${number}${neighborhood ? ` - ${neighborhood}` : ""}, ${
    cities.city
  } - ${cities.states.state}, ${cep}`;
};

export const TableItem = ({ item }: Tableitem) => {
  const history = useHistory();

  const { mutateAsync: deleteUnitMutation } = useMutation({
    mutationFn: deleteUnit,
    onSuccess: async (data: any) => {
      createToast("success", `Unidade  N°${data.id} alterada com sucesso!`);
      //   setInactive(true);
      //   await fetchAllUnits();
    },
    onError: (error: any) => {
      console.log(error);
    },
  });

  const handleDeleteUnit = async (id: number) => {
    await deleteUnitMutation(id);
  };

  return (
    <tr>
      <td>{item.name}</td>
      <td>{item.regions?.region}</td>
      <td>{TextEllipsis(formatAddressToString(item.addresses), 70)} </td>
      <td>{item.addresses.cities.city}</td>
      <td>{item.deleted_at === null ? "Ativa" : "Inativa"}</td>
      <td>{CapitalizeFirstLetter(item.type)}</td>
      <td className="text-right table-action regionTable">
        <div className="flex-buttons">
          <button
            type="button"
            className="button _blue _action"
            onClick={() => history.push(`unidades/${item.id}`)}
          >
            Editar
          </button>
          <button
            type="button"
            className={`${
              item.deleted_at !== null && "_buttonDisabled"
            } button _yellow _action`}
            onClick={() => handleDeleteUnit(item.id)}
          >
            <span className="details-text">
              {item.deleted_at === null ? "Desativar" : "Ativar"}
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
};
